export default "__VITE_ASSET__CBEnHmSh__"